import React from "react"

export const H4 = ({ children }) => {
  return <h4 className="mb-5 mt-16 font-bold text-3xl">{children} </h4>
}
